var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 18,
    fill: "#ffd45c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd45c",
    strokeWidth: 7,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 8v12M48 76v12M8 48h12M76 48h12M20 20l9 9M67 67l9 9M76 20l-9 9M29 67l-9 9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.e35f701474a8d4a8cdc69777ef0fc17e.svg";
export { ForwardRef as ReactComponent };